<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading" @on-cancel="cancel" class="mask" :class-name="z100000" width="650">
      <h3 slot="header" class="modal-header">录入交割信息</h3>
      <Table :columns="columns" :data="data"></Table>
    </Modal>

  </div>
</template>
<script>
  export default {
    name: "GoodsDetail"   ,  //企业交割录入   物品信息明细
    components:{
    },
    props:{
      n: {
        type: Number,
        default: 0
      },
    },
    watch:{
      n(){
        this.isShow=true
      }
    },
    data(){
      return {
        z100000:'z100000',
        loading: true,
        isShow:false,
        columns:[
          {
            title: "物品名称",
            // width: 130,
            key: "",
            align: "center"
          },
          {
            title: "大类",
            // width: 130,
            key: "",
            align: "center"
          },
          {
            title: "数量",
            // width: 130,
            key: "",
            align: "center"
          },
          {
            title: "价格",
            // width: 130,
            key: "",
            align: "center"
          },
          {
            title: "状态",
            // width: 130,
            key: "",
            align: "center"
          },
        ],
        data:[{test:1}]
      }
    },
    methods:{
      ok(){

      },
      cancel(){

      }
    }

  }
</script>

<style scoped>

</style>
